export class EndRide {
 public bookingTripSummaryId: number;
 public contractTypeGroupId: string;
 public endDateTime: string;
 public endLatitude: number;
 public endLongitude:number;
 public endMileage:number;
 public bookingHashId: string;
 public tripHashId: string;
 public locationExchangeHashId: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/EndRide.ts